import { ThemeUIStyleObject } from 'theme-ui';

export const headerContainerStyles: ThemeUIStyleObject = {
  position: 'sticky',
  top: 0,
  zIndex: 100,
  bg: 'neutral/000',
  borderBottom: '1px solid',
  borderColor: 'neutral/300',
  px: ['1rem', '5rem'],
  py: ['0.75rem', '0'],
  height: ['auto', '4rem'],
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: ['0.75rem', '0'],
  flexDirection: ['column', 'row'],
};

// Mobile-specific rows
export const headerTopRowStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const periodToggleRowStyles: ThemeUIStyleObject = {
  width: '100%',
  justifyContent: 'flex-start',
};

export const searchFilterRowStyles: ThemeUIStyleObject = {
  width: '100%',
  gap: '0.5rem',
  alignItems: 'center',
};

export const resultsRowStyles: ThemeUIStyleObject = {
  width: '100%',
  justifyContent: 'flex-start',
};

// Desktop-specific sections
export const leftSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '2rem',
  flex: 1,
};

export const desktopLogoStyles: ThemeUIStyleObject = {
  display: 'block',
};

export const filtersSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '1rem',
  flexDirection: 'row',
};

export const rightSectionStyles: ThemeUIStyleObject = {
  alignItems: 'center',
};

// Shared component wrappers
export const searchInputWrapperStyles: ThemeUIStyleObject = {
  flex: ['6', '1'],
  minWidth: 0,
};

export const selectButtonWrapperStyles: ThemeUIStyleObject = {
  flex: ['4', '0 0 auto'],
  minWidth: '5rem',
};

export const resultsTextStyles: ThemeUIStyleObject = {
  fontSize: ['0.625rem', '0.75rem'],
  textAlign: ['left', 'center'],
  color: 'neutral/600',
};
